{
  "app.name": "AI Smart Factory",
  "app.skipToContent": "Skip to content",
  "nav.primary": "Main navigation",
  "nav.home": "Dashboard",
  "nav.breadcrumb": "Breadcrumb",
  "nav.collapse": "Collapse sidebar",
  "nav.expand": "Expand sidebar",
  "nav.modelManagement": "Model Management",
  "nav.modelRegistry": "Model Registry",
  "nav.modelTraining": "Model Training",
  "home.title": "Dashboard",
  "home.emptyTitle": "The platform foundation is ready",
  "home.emptyDescription": "Enabled modules appear here. Modules are enabled in the runtime configuration.",
  "home.moduleCountOne": "{count} module enabled",
  "home.moduleCountMany": "{count} modules enabled",
  "tv.title": "TV display",
  "tv.placeholder": "TV display screens are provided by the tv-display capability.",
  "kiosk.title": "Kiosk",
  "kiosk.placeholder": "Kiosk screens are provided by the qpoint-kiosk capability.",
  "actions.retry": "Try again",
  "actions.reload": "Reload",
  "actions.close": "Close",
  "actions.signOut": "Logout",
  "actions.backToStart": "Back to start",
  "notifications.region": "Notifications",
  "notifications.dismiss": "Dismiss notification",
  "theme.label": "Theme",
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.highContrast": "High contrast",
  "language.label": "Language",
  "auth.title": "Login",
  "auth.subtitle": "Sign in to access your Smart Factory platform.",
  "auth.email": "Your Email",
  "auth.password": "Password",
  "auth.submit": "Sign in",
  "auth.submitting": "Signing in…",
  "auth.invalidCredentials": "The email or password is incorrect.",
  "auth.emailRequired": "Enter your email.",
  "auth.emailInvalid": "Enter a valid email address.",
  "auth.passwordRequired": "Enter your password.",
  "auth.unexpectedError": "Could not sign in. Please try again later.",
  "auth.showPassword": "Show password",
  "auth.forgotPassword": "Forgot password?",
  "auth.heroTitle": "Smart Factory",
  "auth.heroTagline": "Monitor equipment health, detect anomalies, and prevent unexpected downtime.",
  "auth.logoAlt": "Company logo",
  "auth.emailPlaceholder": "Enter email",
  "auth.passwordPlaceholder": "Enter password",
  "auth.reset.title": "Forgot password",
  "auth.reset.description": "Enter your email address and we’ll send you a link to reset your password.",
  "auth.reset.send": "Send",
  "auth.reset.back": "Back to sign in",
  "auth.reset.changeTitle": "Change Password",
  "auth.reset.newPassword": "New Password",
  "auth.reset.confirmPassword": "Confirm Password",
  "auth.reset.confirm": "Confirm",
  "auth.reset.passwordMismatch": "The passwords do not match.",
  "auth.userMenu": "User menu",
  "errors.notFoundTitle": "Page not found",
  "errors.notFoundDescription": "The page does not exist or is not enabled in this installation.",
  "errors.unexpectedTitle": "Something went wrong",
  "errors.unexpectedDescription": "An unexpected error occurred. Please try again.",
  "errors.forbiddenTitle": "Access denied",
  "errors.forbiddenDescription": "You do not have permission to view this page.",
  "errors.chunkTitle": "A new version was deployed",
  "errors.chunkDescription": "Reload the application to load the latest version.",
  "errors.reloading": "Loading the latest version…",
  "fatal.configTitle": "Configuration error",
  "fatal.configDescription": "The runtime configuration (/config.json) could not be loaded or is invalid. Contact your administrator.",
  "buildInfo.open": "Build information",
  "buildInfo.title": "Build information",
  "buildInfo.version": "Version",
  "buildInfo.revision": "Revision",
  "buildInfo.builtAt": "Built at",
  "states.loading": "Loading…",
  "states.empty": "Nothing to show.",
  "status.severity.critical": "Critical",
  "status.severity.warning": "Warning",
  "status.severity.info": "Info",
  "status.severity.ok": "OK",
  "status.lifecycle.draft": "Draft",
  "status.lifecycle.commissioning": "Commissioning",
  "status.lifecycle.shadow": "Shadow (evaluation only)",
  "status.lifecycle.active": "Active",
  "status.lifecycle.maintenance": "Maintenance",
  "status.lifecycle.retired": "Retired",
  "status.connection.label": "Realtime connection",
  "status.connection.idle": "Idle",
  "status.connection.connecting": "Connecting",
  "status.connection.online": "Online",
  "status.connection.degraded": "Degraded",
  "status.connection.offline": "Offline",
  "modelTraining.steps.label": "Model training steps",
  "modelTraining.steps.datasets": "Datasets",
  "modelTraining.steps.preview": "Data Preview",
  "modelTraining.steps.features": "Feature Selection",
  "modelTraining.steps.preprocessing": "Preprocessing",
  "modelTraining.steps.train": "Train Model",
  "modelTraining.steps.completed": "completed",
  "modelTraining.steps.unavailable": "not available yet",
  "modelTraining.actions.previous": "Previous",
  "modelTraining.actions.next": "Next",
  "modelTraining.actions.refresh": "Refresh",
  "modelTraining.actions.delete": "Delete",
  "modelTraining.actions.download": "Download",
  "modelTraining.actions.edit": "Edit",
  "modelTraining.actions.upload": "Upload",
  "modelTraining.actions.cancel": "Cancel",
  "modelTraining.actions.back": "Back",
  "modelTraining.actions.chooseFile": "Choose File",
  "modelTraining.actions.removeFile": "Remove file",
  "modelTraining.actions.autoDetect": "Auto detect",
  "modelTraining.actions.clearFormat": "Clear format",
  "modelTraining.actions.create": "Create",
  "modelTraining.actions.creating": "Creating…",
  "modelTraining.actions.viewSamples": "View Samples",
  "modelTraining.actions.hideSamples": "Hide Samples",
  "modelTraining.actions.update": "Update",
  "modelTraining.actions.updating": "Updating…",
  "modelTraining.actions.deleting": "Deleting…",
  "modelTraining.actions.editDataset": "Edit {name}",
  "modelTraining.notAvailable": "This function is not available yet.",
  "modelTraining.edit.title": "Edit Dataset",
  "modelTraining.edit.name": "Name",
  "modelTraining.edit.description": "Description",
  "modelTraining.edit.nameRequired": "Name is required",
  "modelTraining.edit.descriptionRequired": "Description is required",
  "modelTraining.edit.success": "The dataset was updated.",
  "modelTraining.edit.failed": "The dataset could not be updated. Try again.",
  "modelTraining.delete.title": "Confirm Deletion",
  "modelTraining.delete.confirmOne": "Are you sure you want to delete “{name}”? This action cannot be undone.",
  "modelTraining.delete.confirmMany": "Are you sure you want to delete {count} selected datasets? This action cannot be undone.",
  "modelTraining.delete.successOne": "The dataset was deleted.",
  "modelTraining.delete.successMany": "{count} datasets were deleted.",
  "modelTraining.delete.failed": "The datasets could not be deleted. Try again.",
  "modelTraining.delete.nothingSelected": "Select at least one dataset to delete.",
  "modelTraining.delete.tooMany": "At most {max} datasets can be deleted at once.",
  "modelTraining.upload.title": "Upload dataset",
  "modelTraining.upload.stepsLabel": "Upload steps",
  "modelTraining.upload.stepImport": "Import CSV File",
  "modelTraining.upload.stepFeatures": "Feature Selection",
  "modelTraining.upload.stepCreate": "Create Dataset",
  "modelTraining.upload.dropLabel": "Drag and drop a File here",
  "modelTraining.upload.reading": "Reading the file…",
  "modelTraining.upload.errors.notCsv": "Only CSV files can be uploaded.",
  "modelTraining.upload.errors.empty": "The file is empty.",
  "modelTraining.upload.errors.tooLarge": "The file is too large. The maximum size is {max}.",
  "modelTraining.upload.errors.noHeader": "The file has no header row. The first row must hold the column names.",
  "modelTraining.upload.errors.unreadable": "The file cannot be read.",
  "modelTraining.upload.failures.tooLarge": "The server does not accept a file of this size.",
  "modelTraining.upload.failures.tooMany": "Too many of your uploads are still open on the server. Try again later.",
  "modelTraining.upload.failures.storageUnavailable": "The file storage is not available at the moment. Choose the file again later.",
  "modelTraining.upload.failures.expired": "The upload took too long. Choose the file again.",
  "modelTraining.upload.failures.notFound": "The upload no longer exists. Choose the file again.",
  "modelTraining.upload.failures.failed": "The upload failed. Remove the file and choose it again.",
  "modelTraining.features.selectedTitle": "Selected Features",
  "modelTraining.features.availableTitle": "Not Selected Features",
  "modelTraining.features.itemHeader": "Feature Name",
  "modelTraining.features.metaHeader": "Estimated type",
  "modelTraining.features.countOne": "{formatted} feature",
  "modelTraining.features.countMany": "{formatted} features",
  "modelTraining.features.checkAll": "Check all of {list}",
  "modelTraining.features.moveToSelected": "Move the checked features to Selected Features",
  "modelTraining.features.moveToAvailable": "Move the checked features to Not Selected Features",
  "modelTraining.features.leftOutOne": "{formatted} column cannot be used because its name is missing, repeated or too long.",
  "modelTraining.features.leftOutMany": "{formatted} columns cannot be used because their name is missing, repeated or too long.",
  "modelTraining.features.tooMany": "At most {max} features can be selected.",
  "modelTraining.dataType.double": "double",
  "modelTraining.dataType.integer": "integer",
  "modelTraining.dataType.string": "string",
  "modelTraining.dataType.boolean": "boolean",
  "modelTraining.create.name": "Dataset Name",
  "modelTraining.create.namePlaceholder": "Enter the dataset name",
  "modelTraining.create.description": "Description",
  "modelTraining.create.descriptionPlaceholder": "Enter a description",
  "modelTraining.create.nameTooLong": "The name can have at most {max} characters.",
  "modelTraining.create.uploading": "The file is still uploading. It keeps uploading after the dataset is created; do not close or reload the page until then.",
  "modelTraining.create.uploadFailed": "The upload of the file failed. Go back to the first step and choose the file again.",
  "modelTraining.create.preview": "Dataset Preview",
  "modelTraining.create.previewTimestamp": "Timestamp",
  "modelTraining.create.previewEmpty": "The file has no rows to preview.",
  "modelTraining.create.refusals.nameTaken": "A dataset with this name already exists.",
  "modelTraining.create.refusals.invalidName": "The server does not accept this name.",
  "modelTraining.create.refusals.uploadNotFound": "The uploaded file no longer exists. Go back to the first step and choose the file again.",
  "modelTraining.create.refusals.invalidTimestamp": "The server does not accept the timestamp settings. Change them on the first step.",
  "modelTraining.create.refusals.invalidFeatures": "The server does not accept the selected features. Change them on the Feature Selection step.",
  "modelTraining.create.refusals.failed": "The dataset could not be created. Try again.",
  "modelTraining.overview.title": "Dataset Overview",
  "modelTraining.overview.collapse": "Collapse overview",
  "modelTraining.overview.expand": "Expand overview",
  "modelTraining.overview.total": "Total Dataset",
  "modelTraining.overview.completed": "Completed Dataset",
  "modelTraining.overview.withoutMissing": "Dataset Without Missing Records",
  "modelTraining.overview.issues": "Issues",
  "modelTraining.view.label": "List view",
  "modelTraining.view.table": "Table View",
  "modelTraining.view.card": "Card View",
  "modelTraining.list.title": "Dataset list",
  "modelTraining.list.search": "Search Dataset",
  "modelTraining.list.selectAll": "Select all datasets on this page",
  "modelTraining.list.selectRow": "Select {name}",
  "modelTraining.list.noDescription": "No description",
  "modelTraining.list.showDescription": "Show description of {name}",
  "modelTraining.list.notAvailable": "Not available",
  "modelTraining.list.empty": "There are no datasets.",
  "modelTraining.list.emptySearch": "No datasets found.",
  "modelTraining.list.columns.name": "Dataset Name",
  "modelTraining.list.columns.records": "No. of records",
  "modelTraining.list.columns.features": "No. of features",
  "modelTraining.list.columns.size": "Size",
  "modelTraining.list.columns.description": "Description",
  "modelTraining.list.columns.createdBy": "Created by",
  "modelTraining.list.columns.createdAt": "Created At",
  "modelTraining.list.columns.status": "Status",
  "modelTraining.list.columns.missingRecords": "Missing records",
  "modelTraining.list.columns.action": "Action",
  "modelTraining.list.pagination.navigation": "Dataset list pages",
  "modelTraining.list.pagination.previous": "Previous page",
  "modelTraining.list.pagination.next": "Next page",
  "modelTraining.list.pagination.page": "Page {page}",
  "modelTraining.list.pagination.pageSize": "Rows per page",
  "modelTraining.card.description": "Description",
  "modelTraining.card.createdBy": "Create by",
  "modelTraining.card.createdAt": "Create date",
  "modelTraining.card.records": "Record",
  "modelTraining.card.features": "Feature",
  "modelTraining.card.size": "Size",
  "modelTraining.dataPreview.backToDatasets": "Back to Datasets",
  "modelTraining.dataPreview.notFoundTitle": "Dataset not found",
  "modelTraining.dataPreview.notFoundDescription": "The dataset does not exist or has been deleted.",
  "modelTraining.dataPreview.notCompletedTitle": "Dataset not ready",
  "modelTraining.dataPreview.notCompletedDescription": "Only completed datasets can be previewed.",
  "modelTraining.dataPreview.header.description": "Description",
  "modelTraining.dataPreview.header.createdBy": "Created By",
  "modelTraining.dataPreview.header.createdAt": "Created Date",
  "modelTraining.dataPreview.header.records": "Records",
  "modelTraining.dataPreview.header.features": "Features",
  "modelTraining.dataPreview.header.size": "Size",
  "modelTraining.dataPreview.statistics.title": "Feature Statistics",
  "modelTraining.dataPreview.statistics.feature": "Features",
  "modelTraining.dataPreview.statistics.count": "Count",
  "modelTraining.dataPreview.statistics.mean": "Mean",
  "modelTraining.dataPreview.statistics.std": "Std",
  "modelTraining.dataPreview.statistics.min": "Min",
  "modelTraining.dataPreview.statistics.max": "Max",
  "modelTraining.dataPreview.statistics.missing": "Missing",
  "modelTraining.dataPreview.statistics.empty": "The dataset has no features.",
  "modelTraining.dataPreview.intervals.title": "Data Interval Distribution",
  "modelTraining.dataPreview.intervals.count": "Data Count",
  "modelTraining.dataPreview.intervals.interval": "Data Interval",
  "modelTraining.dataPreview.intervals.seconds": "{value}s",
  "modelTraining.dataPreview.intervals.intervalSeconds": "Data interval (seconds)",
  "modelTraining.dataPreview.intervals.bar": "Interval {interval} s: {count} records",
  "modelTraining.dataPreview.intervals.empty": "The interval distribution is not available.",
  "modelTraining.dataPreview.records.title": "Dataset Preview",
  "modelTraining.dataPreview.records.collapse": "Collapse the dataset preview",
  "modelTraining.dataPreview.records.expand": "Expand the dataset preview",
  "modelTraining.dataPreview.records.limit": "Number of records",
  "modelTraining.dataPreview.records.last": "Last {count} Records",
  "modelTraining.dataPreview.records.timestamp": "Timestamp",
  "modelTraining.dataPreview.records.noValue": "No value",
  "modelTraining.dataPreview.records.empty": "The file has no records.",
  "modelTraining.dataPreview.records.fileMissingTitle": "File not available",
  "modelTraining.dataPreview.records.fileMissing": "The file of this dataset is no longer in the storage.",
  "modelTraining.dataPreview.records.fileUnsupportedTitle": "Preview not possible",
  "modelTraining.dataPreview.records.fileUnsupported": "This file cannot be previewed.",
  "modelTraining.dataPreview.records.storageUnavailableTitle": "Storage not reachable",
  "modelTraining.dataPreview.records.storageUnavailable": "The file storage cannot be reached. Try again later.",
  "modelTraining.featureSelection.countOne": "{formatted} item",
  "modelTraining.featureSelection.countMany": "{formatted} items",
  "modelTraining.featureSelection.numericOnly": "Only numeric columns can be used as features",
  "modelTraining.featureSelection.atLeastOne": "Select at least one feature",
  "modelTraining.featureSelection.notCompletedDescription": "Features can be selected for completed datasets only.",
  "modelTraining.featureSelection.empty": "The dataset has no features.",
  "modelTraining.preprocessing.cleaning.title": "Data Cleaning",
  "modelTraining.preprocessing.missingValues.label": "Null/Missing Values",
  "modelTraining.preprocessing.missingValues.fill_next": "Fill by subsequent value",
  "modelTraining.preprocessing.missingValues.fill_mean": "Fill by mean value",
  "modelTraining.preprocessing.missingValues.interpolate": "Fill by interpolate",
  "modelTraining.preprocessing.missingValues.fill_zero": "Fill by 0",
  "modelTraining.preprocessing.missingValues.drop_rows": "Drop null records",
  "modelTraining.preprocessing.missingValues.none": "No cleaning",
  "modelTraining.preprocessing.outliers.label": "Outliers",
  "modelTraining.preprocessing.outliers.normalize": "Normalize Outliers",
  "modelTraining.preprocessing.outliers.remove": "Remove Outliers",
  "modelTraining.preprocessing.outliers.none": "No Cleaning",
  "modelTraining.preprocessing.method.label": "Method",
  "modelTraining.preprocessing.method.z_score": "Z-Score",
  "modelTraining.preprocessing.method.iqr": "IQR",
  "modelTraining.preprocessing.method.modified_z_score": "Modified Z-Score",
  "modelTraining.preprocessing.method.grubbs": "Grubbs",
  "modelTraining.preprocessing.method.ema": "EMA",
  "modelTraining.preprocessing.method.gesd": "GESD",
  "modelTraining.preprocessing.threshold.label": "Threshold",
  "modelTraining.preprocessing.threshold.required": "This field is required",
  "modelTraining.preprocessing.threshold.positive": "Threshold must be greater than 0",
  "modelTraining.preprocessing.filtering.title": "Data Filtering",
  "modelTraining.preprocessing.filtering.add": "Add Column",
  "modelTraining.preprocessing.filtering.group": "Filter {index}",
  "modelTraining.preprocessing.filtering.column": "Column Name {index}",
  "modelTraining.preprocessing.filtering.columnPlaceholder": "Select",
  "modelTraining.preprocessing.filtering.lower": "Lower Boundary",
  "modelTraining.preprocessing.filtering.upper": "Upper Boundary",
  "modelTraining.preprocessing.filtering.remove": "Remove filter {index}",
  "modelTraining.preprocessing.filtering.error.bounds": "Lower Boundary and Upper Boundary must be numbers",
  "modelTraining.preprocessing.filtering.error.order": "Lower Boundary must not be greater than Upper Boundary",
  "modelTraining.preprocessing.notCompletedDescription": "Preprocessing can be configured for completed datasets only.",
  "modelTraining.preprocessing.noFeaturesTitle": "No feature selected",
  "modelTraining.preprocessing.backToFeatures": "Back to Feature Selection",
  "modelTraining.train.notCompletedDescription": "A model can be trained on completed datasets only.",
  "modelTraining.train.selection.title": "Train Model",
  "modelTraining.train.modelType.label": "Select Model Type",
  "modelTraining.train.framework.label": "Select Framework",
  "modelTraining.train.algorithm.label": "Select Algorithm/Model",
  "modelTraining.train.target.title": "Target Column",
  "modelTraining.train.target.description": "The column the model learns to predict. Only columns not selected as features are listed.",
  "modelTraining.train.target.featuresSelectedOne": "{count} feature selected",
  "modelTraining.train.target.featuresSelectedMany": "{count} features selected",
  "modelTraining.train.target.label": "Target Column",
  "modelTraining.train.target.classCount": "{count} classes",
  "modelTraining.train.target.single": "Fewer than two values: cannot be learned",
  "modelTraining.train.target.uncounted": "More than 50 values or not counted",
  "modelTraining.train.target.decimal": "Decimal column: cannot be the target",
  "modelTraining.train.target.unsupported": "This data type cannot be the target",
  "modelTraining.train.target.decimalReason": "\"{name}\" is a decimal column and cannot be the target. Choose an integer, string or boolean column with at least two values.",
  "modelTraining.train.target.singleReason": "\"{name}\" has {count} distinct value(s): a model cannot learn fewer than two classes. Choose another column.",
  "modelTraining.train.target.unsupportedReason": "\"{name}\" has the data type {type} and cannot be the target. Choose an integer, string or boolean column with at least two values.",
  "modelTraining.train.target.unusable": "This column cannot be the target. Choose another column.",
  "modelTraining.train.target.choose": "Choose a target column to see its classes.",
  "modelTraining.train.target.classesHeading": "{count} classes in \"{name}\"",
  "modelTraining.train.target.rows": "{count} rows",
  "modelTraining.train.target.caption": "Classes of the target column",
  "modelTraining.train.target.column.class": "Class",
  "modelTraining.train.target.column.share": "Share",
  "modelTraining.train.target.column.samples": "Samples",
  "modelTraining.train.target.missingRows": "{count} rows without a value are not counted in any class.",
  "modelTraining.train.target.imbalanced": "Classes are imbalanced (largest is {ratio}× the smallest).",
  "modelTraining.train.target.notCounted": "Classes not available: the column has more than 50 values, or the dataset was processed before values were counted. Create the dataset again to see its classes.",
  "modelTraining.train.target.noneTitle": "No column available as target",
  "modelTraining.train.target.noneDescription": "Every column is selected as a feature. Leave the label column out in Feature Selection.",
  "modelTraining.train.target.openFeatures": "Open Feature Selection",
  "modelTraining.train.selectPlaceholder": "Select",
  "modelTraining.train.information.title": "Model Information",
  "modelTraining.train.modelName.label": "Model Name",
  "modelTraining.train.modelName.placeholder": "Model/Display name",
  "modelTraining.train.modelName.required": "Model name is required",
  "modelTraining.train.parameters.caption": "Parameters of the selected algorithm",
  "modelTraining.train.parameters.parameter": "Parameter",
  "modelTraining.train.parameters.dataType": "Data Type",
  "modelTraining.train.parameters.description": "Description",
  "modelTraining.train.parameters.value": "Value",
  "modelTraining.train.parameters.valueLabel": "{name} value",
  "modelTraining.train.parameters.empty": "Select an algorithm to see its parameters.",
  "modelTraining.train.parameters.none": "This algorithm has no parameters.",
  "modelTraining.train.parameters.placeholder.int": "0",
  "modelTraining.train.parameters.placeholder.float": "0.00",
  "modelTraining.train.parameters.placeholder.text": "Type",
  "modelTraining.train.parameters.placeholder.int_list": "64, 32",
  "modelTraining.train.parameters.error.required": "This field is required",
  "modelTraining.train.parameters.error.integer": "{name} must be an integer",
  "modelTraining.train.parameters.error.number": "{name} must be a number",
  "modelTraining.train.parameters.error.intList": "{name} must be whole numbers separated by commas",
  "modelTraining.train.parameters.error.range": "{name} must be {range}",
  "modelTraining.train.parameters.range.atLeast": "at least {value}",
  "modelTraining.train.parameters.range.above": "greater than {value}",
  "modelTraining.train.parameters.range.atMost": "at most {value}",
  "modelTraining.train.parameters.range.below": "less than {value}",
  "modelTraining.train.parameters.range.both": "{lower} and {upper}",
  "modelTraining.train.parameters.typeLabel": "{name} data type",
  "modelTraining.train.parameters.type.int": "Int",
  "modelTraining.train.parameters.type.float": "Float",
  "modelTraining.train.parameters.type.text": "Text",
  "modelTraining.train.parameters.type.boolean": "Boolean",
  "modelTraining.train.parameters.type.null": "Null",
  "modelTraining.train.parameters.type.int_list": "Int list",
  "modelTraining.train.advanced.title": "Advanced Setting",
  "modelTraining.train.advanced.caption": "Advanced parameters of the selected algorithm",
  "modelTraining.train.advanced.parameter": "Advanced Parameter",
  "modelTraining.train.parameters.boolean.True": "True",
  "modelTraining.train.parameters.boolean.False": "False",
  "modelTraining.train.catalogue.emptyTitle": "No algorithm available",
  "modelTraining.train.catalogue.emptyDescription": "The backend lists no algorithm to train yet.",
  "modelTraining.train.catalogue.errorDescription": "The algorithms could not be loaded.",
  "modelTraining.train.startTraining": "Start Training",
  "modelTraining.train.starting": "Starting…",
  "modelTraining.train.required": "This field is required",
  "modelTraining.train.outliersConflict": "Remove Outliers cannot be used with Anomaly Detection. Choose Normalize Outliers or No Cleaning.",
  "modelTraining.train.preprocessingInvalid": "The preprocessing settings are not complete.",
  "modelTraining.train.openPreprocessing": "Open Preprocessing",
  "modelTraining.train.notTaken": "The model was created, but the training could not be started. {reason} To try again, enter another model name: the created model keeps this one.",
  "modelTraining.train.failed": "The training could not be started. Try again.",
  "modelTraining.train.started.title": "Model has been created. Training is in progress.",
  "modelTraining.train.started.openRegistry": "Open Model Registry",
  "modelTraining.modelType.anomaly_detection": "Anomaly Detection",
  "modelTraining.modelType.fault_classification": "Fault classification",
  "modelTraining.framework.pytorch": "PyTorch",
  "modelTraining.framework.xgboost": "XGBoost",
  "modelTraining.framework.scikit_learn": "scikit-learn",
  "modelTraining.status.in_progress": "In progress",
  "modelTraining.status.completed": "Completed",
  "modelTraining.status.error": "Error",
  "modelTraining.missing.none": "0 missing records",
  "modelTraining.missing.countOne": "{formatted} missing record",
  "modelTraining.missing.countMany": "{formatted} missing records",
  "modelTraining.timestamp.column": "Timestamp Column",
  "modelTraining.timestamp.columnPlaceholder": "Select a column",
  "modelTraining.timestamp.sample": "Sample",
  "modelTraining.timestamp.format": "Timestamp Format",
  "modelTraining.timestamp.formatPlaceholder": "e.g. yyyy-MM-dd HH:mm:ss",
  "modelTraining.timestamp.required": "required",
  "modelTraining.timestamp.noSample": "The chosen column has no sample value.",
  "modelTraining.timestamp.valid": "Format is valid and can parse the sample data",
  "modelTraining.timestamp.mismatch": "The format does not match the sample.",
  "modelTraining.timestamp.noDate": "The format needs a year (yyyy), a month (MM) and a day (dd).",
  "modelTraining.timestamp.notDetected": "No known format matches the sample. Enter the format yourself.",
  "modelTraining.download.selectFirst": "Select a dataset to download.",
  "modelTraining.download.count": "Download ({count})",
  "modelTraining.download.labelOne": "Download the selected dataset",
  "modelTraining.download.labelMany": "Download {count} datasets as one archive",
  "modelTraining.download.started": "Download started: {fileName}",
  "modelTraining.download.notFound": "This dataset no longer exists.",
  "modelTraining.download.fileMissing": "This dataset has no file to download.",
  "modelTraining.download.storageUnavailable": "The file storage is not available at the moment. Try again later.",
  "modelTraining.download.failed": "The download could not be started. Try again.",
  "modelTraining.archive.label": "Archive of datasets",
  "modelTraining.archive.busy": "An archive is already being prepared.",
  "modelTraining.archive.requesting": "The archive is being requested…",
  "modelTraining.archive.preparing": "Preparing an archive of {count} datasets ({size})…",
  "modelTraining.archive.preparingHint": "You can keep working. The download starts when it is ready.",
  "modelTraining.archive.unreadable": "The state of the archive cannot be read at the moment. Trying again…",
  "modelTraining.archive.ready": "{fileName} ({size}) is ready.",
  "modelTraining.archive.availableUntil": "Available until {time}",
  "modelTraining.archive.download": "Download",
  "modelTraining.archive.downloadFailed": "The archive could not be downloaded. Try again.",
  "modelTraining.archive.started": "Download of the archive started: {fileName}",
  "modelTraining.archive.failed": "The archive could not be created. Download failed, please try again.",
  "modelTraining.archive.failedTitle": "The archive could not be created.",
  "modelTraining.archive.expired": "The archive is no longer available. Request it again.",
  "modelTraining.archive.dismiss": "Dismiss",
  "modelTraining.archive.refused.notFound": "These datasets no longer exist: {names}",
  "modelTraining.archive.refused.notFoundUnnamed": "A selected dataset no longer exists.",
  "modelTraining.archive.refused.fileMissing": "These datasets have no file to download: {names}",
  "modelTraining.archive.refused.fileMissingUnnamed": "A selected dataset has no file to download.",
  "modelTraining.archive.refused.tooMany": "Too many datasets are selected for one archive. Select fewer.",
  "modelTraining.archive.refused.tooLarge": "The selected datasets are too large for one archive. Select fewer.",
  "modelTraining.archive.refused.tooManyWaiting": "An earlier archive must finish first.",
  "modelTraining.archive.refused.failed": "The archive could not be requested. Try again.",
  "modelRegistry.tabs.label": "Model registry pages",
  "modelRegistry.tabs.models": "Models",
  "modelRegistry.tabs.experiment": "Experiment",
  "modelRegistry.tabs.evaluation": "Evaluation",
  "modelRegistry.notAvailable": "This function is not available yet.",
  "modelRegistry.overview.title": "Model Overview",
  "modelRegistry.overview.collapse": "Collapse overview",
  "modelRegistry.overview.expand": "Expand overview",
  "modelRegistry.overview.total": "Total Models",
  "modelRegistry.overview.running": "Running Models",
  "modelRegistry.overview.completedTraining": "Completed Training",
  "modelRegistry.overview.issues": "Issues",
  "modelRegistry.list.title": "Model list",
  "modelRegistry.list.search": "Search models",
  "modelRegistry.list.empty": "No models match the current search or filter.",
  "modelRegistry.list.notAvailable": "Not available",
  "modelRegistry.list.selectAll": "Select all models on this page",
  "modelRegistry.list.selectRow": "Select {name}",
  "modelRegistry.list.columns.name": "Models Name",
  "modelRegistry.list.columns.modelType": "Model Type",
  "modelRegistry.list.columns.datasetName": "Dataset Name",
  "modelRegistry.list.columns.createdBy": "Created by",
  "modelRegistry.list.columns.createdAt": "Created At",
  "modelRegistry.list.columns.trainingStatus": "Training Status",
  "modelRegistry.list.columns.deploymentStatus": "Deployment Status",
  "modelRegistry.list.columns.action": "Action",
  "modelRegistry.list.pagination.navigation": "Model list pages",
  "modelRegistry.list.pagination.previous": "Previous page",
  "modelRegistry.list.pagination.next": "Next page",
  "modelRegistry.list.pagination.page": "Page {page}",
  "modelRegistry.list.pagination.pageSize": "Rows per page",
  "modelRegistry.training.inProgress": "In-progress",
  "modelRegistry.training.completed": "Completed",
  "modelRegistry.training.error": "Error",
  "modelRegistry.deployment.notDeployed": "Not deployed",
  "modelRegistry.deployment.inProgress": "In-progress",
  "modelRegistry.deployment.deployed": "Deployed",
  "modelRegistry.deployment.stopping": "Stopping",
  "modelRegistry.deployment.stopped": "Stopped",
  "modelRegistry.deployment.error": "Error",
  "modelRegistry.status.reason": "{status}: {reason}",
  "modelRegistry.actions.deploy": "Deploy",
  "modelRegistry.actions.stop": "Stop",
  "modelRegistry.actions.evaluation": "Evaluation",
  "modelRegistry.actions.experiment": "Experiment",
  "modelRegistry.actions.of": "{action} {name}",
  "modelRegistry.reasons.trainingInProgress": "The training is still in progress.",
  "modelRegistry.reasons.trainingFailed": "The training has failed.",
  "modelRegistry.reasons.deploymentInProgress": "The model is being deployed.",
  "modelRegistry.reasons.stopping": "The model is being stopped.",
  "modelRegistry.reasons.notDeployed": "The model is not deployed.",
  "modelRegistry.reasons.statusUnknown": "The status of this model is not known.",
  "modelRegistry.deployDialog.deployTitle": "Deploy {name}?",
  "modelRegistry.deployDialog.deployDescription": "The model serves predictions once the inference service has loaded it. This can take a few minutes.",
  "modelRegistry.deployDialog.contextLoading": "Checking whether the model can be deployed…",
  "modelRegistry.deployDialog.contextError": "The deployment check could not be loaded.",
  "modelRegistry.deployDialog.blocked": "This model cannot be deployed:",
  "modelRegistry.deployDialog.gates": "{passed} of {configured} quality gates passed",
  "modelRegistry.deployDialog.parallel": "These models of the same dataset and type stay deployed:",
  "modelRegistry.deployDialog.note.label": "Note (optional)",
  "modelRegistry.deployDialog.note.placeholder": "Why this model is deployed",
  "modelRegistry.deployDialog.note.count": "{count} / {max}",
  "modelRegistry.deployDialog.note.tooLong": "At most {max} characters.",
  "modelRegistry.deployDialog.cancel": "Cancel",
  "modelRegistry.deployDialog.deploy": "Deploy",
  "modelRegistry.deployDialog.deploying": "Deploying…",
  "modelRegistry.deployDialog.deployStarted": "Deployment of {name} started.",
  "modelRegistry.deployDialog.stopTitle": "Stop {name}?",
  "modelRegistry.deployDialog.stopDescription": "The model stops serving predictions. Predictions that are already running may finish.",
  "modelRegistry.deployDialog.stop": "Stop",
  "modelRegistry.deployDialog.stopping": "Stopping…",
  "modelRegistry.deployDialog.stopStarted": "Stopping {name}.",
  "modelRegistry.deployDialog.alreadyStopped": "{name} is already stopped.",
  "modelRegistry.deployDialog.failed": "The action could not be done. Try again.",
  "modelRegistry.deployDialog.refusals.notFound": "This model no longer exists.",
  "modelRegistry.deployDialog.refusals.notDeployable": "This model cannot be deployed or stopped in its current state.",
  "modelRegistry.deployDialog.refusals.qualityGatesFailed": "The model does not pass its quality gates.",
  "modelRegistry.deployDialog.refusals.inFlight": "A deployment of this model is already in progress.",
  "modelRegistry.deployDialog.refusals.alreadyDeployed": "This model is already deployed.",
  "modelRegistry.deployDialog.refusals.inferenceUnavailable": "The inference service is not available.",
  "modelRegistry.card.datasetName": "Dataset Name",
  "modelRegistry.card.createdBy": "Created by",
  "modelRegistry.actions.refresh": "Refresh",
  "modelRegistry.actions.delete": "Delete",
  "modelRegistry.actions.download": "Download",
  "modelRegistry.view.label": "List view",
  "modelRegistry.view.table": "Table View",
  "modelRegistry.view.card": "Card view",
  "modelRegistry.filter.label": "Filter by Type:",
  "modelRegistry.modelType.anomaly_detection": "Anomaly Detection",
  "modelRegistry.modelType.fault_classification": "Fault classification",
  "modelRegistry.experiment.title": "New experiment",
  "modelRegistry.experiment.description": "Run the deployed model on new data. Experiments never send alerts to maintenance and do not change the evaluation.",
  "modelRegistry.experiment.run": "Run experiment",
  "modelRegistry.experiment.notCompleted": "Experiments can be run once the training of this model has completed.",
  "modelRegistry.experiment.source.label": "Data source",
  "modelRegistry.experiment.source.system": "System data",
  "modelRegistry.experiment.source.upload": "Upload file",
  "modelRegistry.experiment.source.systemUnavailable": "System data is not available for this model type.",
  "modelRegistry.experiment.timeRange.label": "Time range",
  "modelRegistry.experiment.timeRange.24h": "Last 24 hours",
  "modelRegistry.experiment.timeRange.7d": "Last 7 days",
  "modelRegistry.experiment.timeRange.30d": "Last 30 days",
  "modelRegistry.experiment.timeRange.period": "{from} – {to}",
  "modelRegistry.experiment.upload.steps": "Upload steps",
  "modelRegistry.experiment.upload.step.upload": "Upload file",
  "modelRegistry.experiment.upload.step.preview": "Preview",
  "modelRegistry.experiment.upload.step.map": "Map attributes",
  "modelRegistry.experiment.upload.done": "done",
  "modelRegistry.experiment.upload.dropLabel": "CSV file with a timestamp column and the model's sensor columns",
  "modelRegistry.experiment.upload.choose": "Choose File",
  "modelRegistry.experiment.upload.template": "Download template",
  "modelRegistry.experiment.upload.templateHint": "The template has the exact column names of this model.",
  "modelRegistry.experiment.upload.reading": "Reading the file…",
  "modelRegistry.experiment.upload.remove": "Remove the file",
  "modelRegistry.experiment.upload.columnsOne": "{count} column",
  "modelRegistry.experiment.upload.columnsMany": "{count} columns",
  "modelRegistry.experiment.upload.errors.notCsv": "Only CSV files (.csv) are accepted.",
  "modelRegistry.experiment.upload.errors.empty": "The file is empty.",
  "modelRegistry.experiment.upload.errors.noHeader": "The first row of the file must contain the column names.",
  "modelRegistry.experiment.upload.errors.unreadable": "The file could not be read.",
  "modelRegistry.experiment.preview.title": "File preview · first {count} rows",
  "modelRegistry.experiment.preview.noRows": "The file has no data rows.",
  "modelRegistry.experiment.preview.another": "Choose another file",
  "modelRegistry.experiment.preview.next": "Next: Map attributes",
  "modelRegistry.experiment.map.title": "Map attributes",
  "modelRegistry.experiment.map.input": "Model input",
  "modelRegistry.experiment.map.column": "Column in the file",
  "modelRegistry.experiment.map.status": "Status",
  "modelRegistry.experiment.map.timestamp": "Timestamp",
  "modelRegistry.experiment.map.target": "Target Column",
  "modelRegistry.experiment.map.optional": "(optional)",
  "modelRegistry.experiment.map.columnFor": "Column for {input}",
  "modelRegistry.experiment.map.noColumn": "Not mapped",
  "modelRegistry.experiment.map.mapped": "Mapped",
  "modelRegistry.experiment.map.notMapped": "Not mapped",
  "modelRegistry.experiment.map.targetHint": "Target Column: the class of each row. With a target column, the accuracy, the macro F1 and the quality gates can be calculated.",
  "modelRegistry.experiment.map.back": "Back",
  "modelRegistry.experiment.map.missing": "Map the timestamp and every model input first.",
  "modelRegistry.experiment.history.title": "Run history",
  "modelRegistry.experiment.notDeployed": "Deploy this model to run experiments.",
  "modelRegistry.experiment.running": "Running…",
  "modelRegistry.experiment.runningHint": "Scoring can take up to a minute.",
  "modelRegistry.experiment.runTitle": "Run #{runNo}",
  "modelRegistry.experiment.runBlocked.uploading": "Wait until the file is uploaded.",
  "modelRegistry.experiment.runBlocked.uploadFailed": "The file could not be uploaded. Try again or choose another file.",
  "modelRegistry.experiment.runBlocked.inProgress": "Another run of this model is in progress.",
  "modelRegistry.experiment.runErrors.running": "Another run of this model is in progress. Wait until it has finished.",
  "modelRegistry.experiment.runErrors.timestampFormat": "This model's training data has no timestamp format, so it cannot be run on a file.",
  "modelRegistry.experiment.runErrors.notDeployed": "This model is no longer deployed.",
  "modelRegistry.experiment.runErrors.notFound": "This model no longer exists.",
  "modelRegistry.experiment.runErrors.retry": "The experiment could not be started. Try again.",
  "modelRegistry.experiment.upload.templateFailed": "The template could not be downloaded. Try again.",
  "modelRegistry.experiment.upload.uploading": "Uploading {percent} %",
  "modelRegistry.experiment.upload.uploaded": "Uploaded",
  "modelRegistry.experiment.upload.retry": "Try again",
  "modelRegistry.experiment.upload.errors.uploadAgain": "The uploaded file is no longer available. Choose the file again.",
  "modelRegistry.experiment.upload.failures.tooLarge": "The server does not accept a file of this size.",
  "modelRegistry.experiment.upload.failures.tooMany": "Too many of your uploads are still open on the server. Try again later.",
  "modelRegistry.experiment.upload.failures.storageUnavailable": "The file storage is not available. Try again later.",
  "modelRegistry.experiment.upload.failures.expired": "The upload took too long. Try again.",
  "modelRegistry.experiment.upload.failures.notFound": "The upload no longer exists. Try again.",
  "modelRegistry.experiment.upload.failures.failed": "The upload failed. Try again.",
  "modelRegistry.experiment.history.loading": "Loading the run history…",
  "modelRegistry.experiment.history.loadError": "The run history could not be loaded.",
  "modelRegistry.experiment.history.empty": "No experiment has been run on this model yet.",
  "modelRegistry.experiment.history.byAt": "{user} · {at}",
  "modelRegistry.experiment.history.more": "Show more",
  "modelRegistry.experiment.detail.loading": "Loading the run…",
  "modelRegistry.experiment.detail.loadError": "The run could not be loaded.",
  "modelRegistry.experiment.detail.notFound": "This run no longer exists.",
  "modelRegistry.experiment.detail.overlap": "Part of this file ({from} – {to}) was used to train or evaluate the model. Results for that period are not a fair test.",
  "modelRegistry.experiment.detail.resultsNotAvailable": "The results of a run are not available yet.",
  "modelRegistry.experiment.detail.chartsNotAvailable": "The anomaly score timeline and the predictions are not available yet.",
  "modelRegistry.experiment.results.label": "Results",
  "modelRegistry.experiment.runResultsTitle": "Run #{runNo} results",
  "modelRegistry.experiment.detail.line": "Upload · {file} · {from} – {to} · run by {user} at {requestedAt}",
  "modelRegistry.experiment.results.rowsScored": "Rows scored",
  "modelRegistry.experiment.results.windowsScored": "Windows scored",
  "modelRegistry.experiment.results.period.seconds": "{value} seconds of data",
  "modelRegistry.experiment.results.period.secondsOne": "{value} second of data",
  "modelRegistry.experiment.results.period.minutes": "{value} minutes of data",
  "modelRegistry.experiment.results.period.minutesOne": "{value} minute of data",
  "modelRegistry.experiment.results.period.hours": "{value} hours of data",
  "modelRegistry.experiment.results.period.days": "{value} days of data",
  "modelRegistry.experiment.results.aboveThreshold": "Rows above the threshold",
  "modelRegistry.experiment.results.windowsAboveThreshold": "Windows above the threshold",
  "modelRegistry.experiment.result.loading": "Loading the results of the run…",
  "modelRegistry.experiment.result.loadError": "The results of the run could not be loaded.",
  "modelRegistry.experiment.result.missing": "The result file of this run is no longer available.",
  "modelRegistry.experiment.timeline.title": "Anomaly score timeline",
  "modelRegistry.experiment.timeline.subtitle": "Highest score per bucket · red = at least one alert in the bucket",
  "modelRegistry.experiment.timeline.periodAxis": "Period (time as written in the file)",
  "modelRegistry.experiment.timeline.chartLabel": "Anomaly score from {start} to {end}: {buckets} buckets, {alerts} with an alert",
  "modelRegistry.experiment.predictions.title": "Predictions",
  "modelRegistry.experiment.predictions.subtitle": "{count} rows in this run · threshold {threshold} · {size} per page",
  "modelRegistry.experiment.predictions.subtitleNoThreshold": "{count} rows in this run · {size} per page",
  "modelRegistry.experiment.predictions.subtitleWindows": "{count} windows in this run · threshold {threshold} · {size} per page",
  "modelRegistry.experiment.predictions.subtitleWindowsNoThreshold": "{count} windows in this run · {size} per page",
  "modelRegistry.experiment.predictions.filter": "Show rows",
  "modelRegistry.experiment.predictions.filterWindows": "Show windows",
  "modelRegistry.experiment.predictions.filters.all": "All rows",
  "modelRegistry.experiment.predictions.filters.allWindows": "All windows",
  "modelRegistry.experiment.predictions.filters.alerts": "Alerts",
  "modelRegistry.experiment.predictions.filters.normal": "No alert",
  "modelRegistry.experiment.predictions.row": "Row",
  "modelRegistry.experiment.predictions.window": "Window",
  "modelRegistry.experiment.predictions.startRow": "Start row",
  "modelRegistry.experiment.predictions.endRow": "End row",
  "modelRegistry.experiment.predictions.windowStart": "Window start",
  "modelRegistry.experiment.predictions.windowEnd": "Window end",
  "modelRegistry.experiment.predictions.timestamp": "Timestamp",
  "modelRegistry.experiment.predictions.score": "Anomaly score",
  "modelRegistry.experiment.predictions.alert": "Alert",
  "modelRegistry.experiment.predictions.isAlert": "Alert",
  "modelRegistry.experiment.predictions.noAlert": "No",
  "modelRegistry.experiment.predictions.empty": "No row matches this filter.",
  "modelRegistry.experiment.predictions.emptyWindows": "No window matches this filter.",
  "modelRegistry.experiment.predictions.showing": "Showing {first}–{last} of {total} rows",
  "modelRegistry.experiment.predictions.showingWindows": "Showing {first}–{last} of {total} windows",
  "modelRegistry.experiment.predictions.pagination": "Pages of the predictions",
  "modelRegistry.experiment.results.alerts": "Alerts",
  "modelRegistry.experiment.results.alertRate": "Alert rate",
  "modelRegistry.experiment.results.threshold": "Threshold {value}",
  "modelRegistry.experiment.detail.classesNotAvailable": "The predicted classes and the predictions are not available yet.",
  "modelRegistry.experiment.results.accuracy": "Accuracy",
  "modelRegistry.experiment.results.macroF1": "Macro F1",
  "modelRegistry.experiment.results.labeledRowsOne": "{count} row",
  "modelRegistry.experiment.results.labeledRowsMany": "{count} rows",
  "modelRegistry.experiment.results.balancedAcrossOne": "Balanced across {count} class",
  "modelRegistry.experiment.results.balancedAcrossMany": "Balanced across {count} classes",
  "modelRegistry.experiment.results.evaluation": "Evaluation {value} ({delta} pp)",
  "modelRegistry.experiment.classTimeline.title": "Predicted class over time",
  "modelRegistry.experiment.classTimeline.eachDot": "Each dot is a row",
  "modelRegistry.experiment.classTimeline.eachDotRows": "Each dot is up to {count} rows",
  "modelRegistry.experiment.classTimeline.ringNote": "red ring = misclassified",
  "modelRegistry.experiment.classTimeline.misclassified": "Misclassified",
  "modelRegistry.experiment.classTimeline.axis": "Time (as in the file)",
  "modelRegistry.experiment.classTimeline.dot": "{time} · predicted {class}",
  "modelRegistry.experiment.classTimeline.dotRows": "{time} · predicted {class} in {rows} rows",
  "modelRegistry.experiment.classTimeline.dotMisclassified": "{detail} · misclassified",
  "modelRegistry.experiment.classTimeline.chartLabel": "Predicted class of each row from {start} to {end}; classes {classes}; {misclassified} misclassified rows",
  "modelRegistry.experiment.predictions.probability": "Probability",
  "modelRegistry.experiment.predictions.misclassified": "Misclassified",
  "modelRegistry.experiment.matrix.caption": "{count} labeled rows · {classes} classes",
  "modelRegistry.experiment.predictions.predictedClass": "Predicted class",
  "modelRegistry.experiment.predictions.actualClass": "Actual class",
  "modelRegistry.experiment.predictions.outcome": "Result",
  "modelRegistry.experiment.predictions.correct": "Correct",
  "modelRegistry.experiment.predictions.filters.correct": "Correct only",
  "modelRegistry.experiment.predictions.filters.incorrect": "Misclassified only",
  "modelRegistry.experiment.predictions.filters.class": "Predicted: {name}",
  "modelRegistry.evaluation.back": "← Back to Models",
  "modelRegistry.evaluation.subtitle.dataset": "Dataset: {name}",
  "modelRegistry.evaluation.subtitle.createdBy": "Created by {name}",
  "modelRegistry.evaluation.subtitle.trained": "Trained {time}",
  "modelRegistry.evaluation.tabs.label": "Evaluation sections",
  "modelRegistry.evaluation.tabs.overview": "Overview",
  "modelRegistry.evaluation.tabs.performance": "Performance",
  "modelRegistry.evaluation.tabs.samplePredictions": "Sample Predictions",
  "modelRegistry.evaluation.samples.title": "Sample predictions (test set)",
  "modelRegistry.evaluation.samples.subtitleOne": "evaluation-explainability.json · {rows} row · {size} per page",
  "modelRegistry.evaluation.samples.showingOne": "Showing {first}–{last} of {total} row",
  "modelRegistry.evaluation.samples.failed": "The training failed, so there are no sample predictions.",
  "modelRegistry.evaluation.samples.subtitle": "evaluation-explainability.json · {rows} rows · {size} per page",
  "modelRegistry.evaluation.samples.empty": "The file has no rows.",
  "modelRegistry.evaluation.samples.showing": "Showing {first}–{last} of {total} rows",
  "modelRegistry.evaluation.samples.page": "Page {page} of {pages}",
  "modelRegistry.evaluation.samples.pagination": "Sample prediction pages",
  "modelRegistry.evaluation.samples.columns.actualClassIndex": "Actual class",
  "modelRegistry.evaluation.samples.columns.predictedClassIndex": "Predicted class",
  "modelRegistry.evaluation.samples.previous": "Previous page",
  "modelRegistry.evaluation.samples.next": "Next page",
  "modelRegistry.evaluation.samples.loading": "Loading the sample predictions…",
  "modelRegistry.evaluation.samples.loadError": "The sample predictions could not be loaded.",
  "modelRegistry.evaluation.samples.notCompleted": "The sample predictions are available once the training is completed.",
  "modelRegistry.evaluation.samples.notAvailable": "The sample predictions are not available for this model.",
  "modelRegistry.evaluation.performance.notCompleted": "The performance is available once the training is completed.",
  "modelRegistry.evaluation.performance.failed": "The training failed, so there is no performance.",
  "modelRegistry.evaluation.performance.notAvailable": "The performance is not available for this model.",
  "modelRegistry.evaluation.performance.loading": "Loading the performance…",
  "modelRegistry.evaluation.performance.loadError": "The performance could not be loaded.",
  "modelRegistry.evaluation.performance.matrixTitle": "Confusion matrix",
  "modelRegistry.evaluation.performance.matrixCaption": "{count} test rows · {classes} classes",
  "modelRegistry.evaluation.performance.predicted": "Predicted class →",
  "modelRegistry.evaluation.performance.actual": "Actual ↓",
  "modelRegistry.evaluation.performance.cellCorrect": "Actual {actual}, predicted {predicted}: {count} ({share}), correct",
  "modelRegistry.evaluation.performance.cellError": "Actual {actual}, predicted {predicted}: {count} ({share}), error",
  "modelRegistry.evaluation.performance.matrixLegend": "Percentages are row-normalized (share of each actual class). Green = correct, red = error.",
  "modelRegistry.evaluation.performance.perClassTitle": "Per-class metrics",
  "modelRegistry.evaluation.performance.perClassCaption": "Test split · ROC-AUC one-vs-rest",
  "modelRegistry.evaluation.performance.class": "Class",
  "modelRegistry.evaluation.performance.precision": "Precision",
  "modelRegistry.evaluation.performance.recall": "Recall",
  "modelRegistry.evaluation.performance.f1": "F1",
  "modelRegistry.evaluation.performance.rocAuc": "ROC-AUC",
  "modelRegistry.evaluation.performance.support": "Support",
  "modelRegistry.evaluation.performance.macroAverage": "Macro average",
  "modelRegistry.evaluation.notAvailableTitle": "This part is not available yet.",
  "modelRegistry.evaluation.notAvailableDescription": "The backend does not provide its data yet.",
  "modelRegistry.evaluation.loading": "Loading the model…",
  "modelRegistry.evaluation.loadError": "The model could not be loaded.",
  "modelRegistry.notFound.title": "Model not found",
  "modelRegistry.notFound.description": "This model may have been deleted.",
  "modelRegistry.notFound.back": "Back to Models",
  "modelRegistry.delete.titleOne": "Delete 1 model?",
  "modelRegistry.delete.titleMany": "Delete {count} models?",
  "modelRegistry.delete.titleNone": "No model can be deleted",
  "modelRegistry.delete.noneDescription": "Every selected model is deployed or in training. Stop it or wait for the training to end.",
  "modelRegistry.delete.warning": "This permanently deletes the selected models, their evaluation results and experiment history. This cannot be undone.",
  "modelRegistry.delete.listLabel": "Models to delete",
  "modelRegistry.delete.skippedOne": "1 model will be skipped",
  "modelRegistry.delete.skippedMany": "{count} models will be skipped",
  "modelRegistry.delete.reason.stopFirst": "Stop the model before deleting it",
  "modelRegistry.delete.reason.trainingInProgress": "Training is in progress",
  "modelRegistry.delete.cancel": "Cancel",
  "modelRegistry.delete.confirm": "Delete",
  "modelRegistry.delete.deleting": "Deleting…",
  "modelRegistry.delete.failed": "The models could not be deleted. Try again.",
  "modelRegistry.delete.outOfDate": "A model changed or was deleted meanwhile, so nothing was deleted. The list was updated.",
  "modelRegistry.delete.nothingSelected": "Select at least one model to delete.",
  "modelRegistry.delete.selectInTable": "Select the models to delete in Table View.",
  "modelRegistry.delete.noPermission": "You don't have permission to delete models",
  "modelRegistry.download.nothingSelected": "Select at least one model to download.",
  "modelRegistry.download.selectInTable": "Select the models to download in Table View.",
  "modelRegistry.download.noPermission": "You don't have permission to download models",
  "modelRegistry.download.preparing": "Preparing…",
  "modelRegistry.download.count": "Download ({count})",
  "modelRegistry.download.noneDownloadable": "Only models with Training Status Completed can be downloaded",
  "modelRegistry.download.skippedOne": "1 model skipped: training not completed",
  "modelRegistry.download.skippedMany": "{count} models skipped: training not completed",
  "modelRegistry.download.failed": "The models could not be downloaded. Try again.",
  "modelRegistry.evaluation.progress": "Training in progress",
  "modelRegistry.evaluation.progressPercent": "Training in progress: {percent}",
  "modelRegistry.evaluation.waiting": "Waiting for the training to start",
  "modelRegistry.evaluation.failed": "The training failed",
  "modelRegistry.evaluation.timeline.title": "Anomaly score over time",
  "modelRegistry.evaluation.timeline.subtitle": "Test period · highest score per bucket · red = at least one alert in the bucket",
  "modelRegistry.evaluation.timeline.below": "Below threshold",
  "modelRegistry.evaluation.timeline.alert": "Alert",
  "modelRegistry.evaluation.timeline.axis": "Anomaly score (log)",
  "modelRegistry.evaluation.timeline.threshold": "Threshold {value}",
  "modelRegistry.evaluation.timeline.bucket": "{start} – {end} · highest {max} · mean {mean} · {flagged}",
  "modelRegistry.evaluation.timeline.flaggedRows": "{flagged} of {count} rows flagged",
  "modelRegistry.evaluation.timeline.flaggedWindows": "{flagged} of {count} windows flagged",
  "modelRegistry.evaluation.timeline.chartLabel": "Anomaly score from {start} to {end}: {buckets} buckets, {alerts} with an alert",
  "modelRegistry.evaluation.timeline.loading": "Loading the anomaly score…",
  "modelRegistry.evaluation.timeline.loadError": "The anomaly score could not be loaded.",
  "modelRegistry.evaluation.anomalyMetrics.label": "Anomaly detection metrics",
  "modelRegistry.evaluation.anomalyMetrics.loading": "Loading the anomaly detection metrics…",
  "modelRegistry.evaluation.anomalyMetrics.alertRate": "Alert rate",
  "modelRegistry.evaluation.anomalyMetrics.alertCount.rows": "{count} of {total} rows",
  "modelRegistry.evaluation.anomalyMetrics.alertCount.windows": "{count} of {total} windows",
  "modelRegistry.evaluation.anomalyMetrics.expected": "expected ≈ {rate}",
  "modelRegistry.evaluation.anomalyMetrics.errorRatio": "Test vs validation error",
  "modelRegistry.evaluation.anomalyMetrics.ratio": "{ratio}×",
  "modelRegistry.evaluation.anomalyMetrics.mse": "Test MSE {test} · validation {validation}",
  "modelRegistry.evaluation.anomalyMetrics.threshold": "Decision threshold",
  "modelRegistry.evaluation.anomalyMetrics.bestEpoch": "Best epoch",
  "modelRegistry.evaluation.anomalyMetrics.epochs": "{best} / {executed}",
  "modelRegistry.evaluation.anomalyMetrics.validationLoss": "Validation loss {loss}",
  "modelRegistry.evaluation.anomalyMetrics.stop.early_stopping": "early stopping",
  "modelRegistry.evaluation.anomalyMetrics.stop.max_epochs": "every epoch run",
  "modelRegistry.evaluation.anomalyMetrics.stop.time_limit": "time limit",
  "modelRegistry.evaluation.classificationMetrics.label": "Classification metrics",
  "modelRegistry.evaluation.classificationMetrics.loading": "Loading the classification metrics…",
  "modelRegistry.evaluation.classificationMetrics.accuracy": "Accuracy",
  "modelRegistry.evaluation.classificationMetrics.correctCount": "{count} of {total} test rows",
  "modelRegistry.evaluation.classificationMetrics.macroPrecision": "Macro precision",
  "modelRegistry.evaluation.classificationMetrics.classMean": "Unweighted mean of {count} classes",
  "modelRegistry.evaluation.classificationMetrics.macroRecall": "Macro recall",
  "modelRegistry.evaluation.classificationMetrics.weakest": "Lowest: {name} {recall}",
  "modelRegistry.evaluation.classificationMetrics.macroF1": "Macro F1",
  "modelRegistry.evaluation.classificationMetrics.balanced": "Balanced precision / recall",
  "modelRegistry.evaluation.classificationMetrics.macroRocAuc": "Macro ROC-AUC",
  "modelRegistry.evaluation.classificationMetrics.oneVsRest": "One-vs-rest",
  "modelRegistry.evaluation.metrics.label": "Metrics",
  "modelRegistry.evaluation.metrics.pending": "Metrics are available when the training completes.",
  "modelRegistry.evaluation.metrics.none": "This model has no metrics.",
  "modelRegistry.evaluation.metrics.split": "{split} split",
  "modelRegistry.evaluation.metrics.class": "Class {name}",
  "modelRegistry.evaluation.metric.reconstruction_error_threshold": "Reconstruction error threshold",
  "modelRegistry.evaluation.metric.reconstruction_mse": "Reconstruction MSE",
  "modelRegistry.evaluation.metric.flagged_fraction": "Flagged rows",
  "modelRegistry.evaluation.metric.anomaly_rate": "Anomaly rate",
  "modelRegistry.evaluation.metric.threshold_percentile": "Threshold percentile",
  "modelRegistry.evaluation.metric.best_epoch": "Best epoch",
  "modelRegistry.evaluation.metric.train_loss": "Training loss",
  "modelRegistry.evaluation.metric.val_loss": "Validation loss",
  "modelRegistry.evaluation.metric.accuracy": "Accuracy",
  "modelRegistry.evaluation.metric.macro_precision": "Precision (macro)",
  "modelRegistry.evaluation.metric.macro_recall": "Recall (macro)",
  "modelRegistry.evaluation.metric.macro_f1": "F1 (macro)",
  "modelRegistry.evaluation.metric.oob_score": "Out-of-bag score",
  "modelRegistry.evaluation.metric.precision": "Precision",
  "modelRegistry.evaluation.metric.recall": "Recall",
  "modelRegistry.evaluation.metric.f1": "F1",
  "modelRegistry.evaluation.split.train": "Train",
  "modelRegistry.evaluation.split.validation": "Validation",
  "modelRegistry.evaluation.split.test": "Test",
  "modelRegistry.evaluation.qualityGates.title": "Quality gates",
  "modelRegistry.evaluation.comparison.title": "Model comparison",
  "modelRegistry.evaluation.qualityGates.subtitle": "Required before deployment · computed by the backend",
  "modelRegistry.evaluation.qualityGates.passedCount": "{passed} / {configured} passed",
  "modelRegistry.evaluation.qualityGates.lowest": "Lowest: {name}",
  "modelRegistry.evaluation.qualityGates.status.passed": "Passed",
  "modelRegistry.evaluation.qualityGates.status.failed": "Failed",
  "modelRegistry.evaluation.qualityGates.status.not_evaluated": "Not reported",
  "modelRegistry.evaluation.qualityGates.status.not_configured": "Threshold not set",
  "modelRegistry.evaluation.qualityGates.banner.passed": "All quality gates passed",
  "modelRegistry.evaluation.qualityGates.banner.passedDeployed": "Deployed · all quality gates passed",
  "modelRegistry.evaluation.qualityGates.banner.passedCount": "All {count} quality gates passed.",
  "modelRegistry.evaluation.qualityGates.banner.passedCountRows": "All {count} quality gates passed on {rows} test rows.",
  "modelRegistry.evaluation.qualityGates.banner.failed": "{failed} of {configured} quality gates failed",
  "modelRegistry.evaluation.qualityGates.banner.evaluatedRows": "Evaluated on {rows} test rows.",
  "modelRegistry.evaluation.comparison.subtitle": "Completed models of the same type, evaluated on the same dataset ({dataset}). Best value in green.",
  "modelRegistry.evaluation.comparison.subtitleRows": "Completed models of the same type, evaluated on the same dataset ({dataset}, {rows} test rows). Best value in green.",
  "modelRegistry.evaluation.comparison.subtitleTarget": "Completed models of the same type, evaluated on the same dataset ({dataset}) and target column ({target}). Best value in green.",
  "modelRegistry.evaluation.comparison.subtitleTargetRows": "Completed models of the same type, evaluated on the same dataset ({dataset}, {rows} test rows) and target column ({target}). Best value in green.",
  "modelRegistry.evaluation.comparison.loading": "Loading the comparison…",
  "modelRegistry.evaluation.comparison.loadError": "The comparison could not be loaded.",
  "modelRegistry.evaluation.comparison.model": "Model",
  "modelRegistry.evaluation.comparison.deploymentStatus": "Deployment Status",
  "modelRegistry.evaluation.comparison.column.accuracy": "Accuracy",
  "modelRegistry.evaluation.comparison.column.macroPrecision": "Macro P",
  "modelRegistry.evaluation.comparison.column.macroRecall": "Macro R",
  "modelRegistry.evaluation.comparison.column.macroF1": "Macro F1",
  "modelRegistry.evaluation.comparison.column.minRecall": "Min. recall",
  "modelRegistry.evaluation.comparison.viewing": "(viewing)",
  "modelRegistry.evaluation.comparison.best": "best",
  "modelRegistry.evaluation.comparison.otherSeed": "Trained on other test rows (another random seed)",
  "modelRegistry.evaluation.comparison.pagination": "Model comparison pages",
  "modelRegistry.evaluation.details.title": "Model details",
  "modelRegistry.evaluation.details.algorithm": "Algorithm",
  "modelRegistry.evaluation.details.framework": "Framework",
  "modelRegistry.evaluation.details.input": "Input",
  "modelRegistry.evaluation.details.inputFeaturesOne": "{count} feature",
  "modelRegistry.evaluation.details.inputFeaturesMany": "{count} features",
  "modelRegistry.evaluation.details.threshold": "Decision threshold",
  "modelRegistry.evaluation.details.thresholdPercentile": "{percentile}th percentile of validation error",
  "modelRegistry.evaluation.details.runId": "Run ID",
  "modelRegistry.evaluation.details.trainedAt": "Trained at",
  "modelRegistry.evaluation.details.trainingTime": "Training time",
  "modelRegistry.evaluation.details.duration": "{minutes} min {seconds} s",
  "modelRegistry.evaluation.details.notAvailable": "Not available",
  "modelRegistry.evaluation.framework.pytorch": "PyTorch",
  "modelRegistry.evaluation.framework.xgboost": "XGBoost",
  "modelRegistry.evaluation.framework.scikit_learn": "scikit-learn",
  "modelRegistry.evaluation.dataset.title": "Dataset & preprocessing",
  "modelRegistry.evaluation.dataset.subtitle": "{name} (snapshot at training time)",
  "modelRegistry.evaluation.dataset.features": "Input features",
  "modelRegistry.evaluation.dataset.target": "Target",
  "modelRegistry.evaluation.dataset.noTarget": "None",
  "modelRegistry.evaluation.dataset.split": "Split",
  "modelRegistry.evaluation.dataset.splitMethod.chronological": "Chronological {ratios}",
  "modelRegistry.evaluation.dataset.splitMethod.random": "Random {ratios}",
  "modelRegistry.evaluation.dataset.splits": "Rows per split",
  "modelRegistry.evaluation.dataset.splitCount": "{split} {count}",
  "modelRegistry.evaluation.dataset.splitsNotAvailable": "Split sizes are not available.",
  "modelRegistry.evaluation.dataset.missingValues": "Missing values",
  "modelRegistry.evaluation.dataset.outliers": "Outliers",
  "modelRegistry.evaluation.dataset.outlierMethod": "{method}, threshold {threshold}",
  "modelRegistry.evaluation.dataset.filters": "Filters",
  "modelRegistry.evaluation.dataset.filter": "{name}: {lower} – {upper}",
  "modelRegistry.evaluation.dataset.noFilters": "None",
  "modelRegistry.evaluation.nullStrategy.none": "No cleaning",
  "modelRegistry.evaluation.nullStrategy.fill_mean": "Fill by mean value",
  "modelRegistry.evaluation.nullStrategy.fill_next": "Fill by subsequent value",
  "modelRegistry.evaluation.nullStrategy.fill_zero": "Fill by 0",
  "modelRegistry.evaluation.nullStrategy.interpolate": "Fill by interpolate",
  "modelRegistry.evaluation.nullStrategy.drop_rows": "Drop null records",
  "modelRegistry.evaluation.outlierStrategy.none": "No cleaning",
  "modelRegistry.evaluation.outlierStrategy.normalize": "Normalize outliers",
  "modelRegistry.evaluation.outlierStrategy.remove": "Remove outliers",
  "modelRegistry.evaluation.outlierMethod.z_score": "Z-Score",
  "modelRegistry.evaluation.outlierMethod.iqr": "IQR",
  "modelRegistry.evaluation.outlierMethod.modified_z_score": "Modified Z-Score",
  "modelRegistry.evaluation.outlierMethod.grubbs": "Grubbs",
  "modelRegistry.evaluation.outlierMethod.ema": "EMA",
  "modelRegistry.evaluation.outlierMethod.gesd": "GESD",
  "modelRegistry.evaluation.hyperparameters.title": "Hyperparameters",
  "modelRegistry.evaluation.hyperparameters.subtitle": "Values sent with Start Training",
  "modelRegistry.evaluation.hyperparameters.none": "No hyperparameters were sent.",
  "modelRegistry.evaluation.hyperparameters.system": "Set by the system",
  "modelRegistry.evaluation.hyperparameters.inputDimension": "input_dimension",
  "modelRegistry.evaluation.hyperparameters.threshold": "threshold",
  "modelRegistry.evaluation.hyperparameters.bestEpoch": "best epoch",
  "modelRegistry.evaluation.hyperparameters.stoppedAt": "{best} (stopped at {stopped})"
}
